import React, { useEffect, useState, useRef } from "react"
import MetaTags from 'react-meta-tags';
import { Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next"
import { withRouter, Link , useHistory} from "react-router-dom"
import { size } from "lodash"
import Loader from "components/Common/Loader"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import SimpleBar from "simplebar-react"
import {
  Card,
  CardBody,
  CardTitle,
  Media,
  CardText,
  CardHeader,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from "reactstrap"
import * as moment from "moment"

import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getSalesEntryList } from "helpers/backend_helper"
import { getSalesChartData } from "helpers/backend_helper"
import ProductSaleGraph from "./ProductSaleGraph"
import { getCustomerSalesSummary } from "helpers/backend_helper"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import {getProductForEditDirect} from "helpers/backend_helper"
import { getAllProducts as onGetAllProducts } from "store/products/actions"
import { getStockBalance as onGetStockBalanceDirect } from "helpers/backend_helper"

const ProductListWithDetails = (props) => {

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(onGetAllProducts())
    dispatch(onGetStoreSettings(true))
  }, [dispatch]);

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setSelectedProductId(params.id)
      getAllDetails(params.id)
    } 
  }, [])

  function getAllDetails(productid){
    getProductDetailsFromId(productid)
    getStockBalance(productid)
    getSalesData(productid,'productsales')

  }

  const getSalesData = async(input,type) => {
    getSalesChartData({
      key : input,
      id: type
    }).then(response => {
      setProductSaleList([
        {
          name: "Sales #",
          data: response,
        },
      ])
      //console.log('response'+JSON.stringify(response))
    })
  }

  function getStockBalance(productid) {
    setStockLoading(true)
    setStockBalance('-')
    onGetStockBalanceDirect({'inputKey':productid}).then(resp =>{
      if(resp && resp.stockbalance){
        setStockBalance(resp.stockbalance)

        if(Number(resp.stockbalance) < Number(productDetails.stockalertlevel)){
          setStockBalanceBgColour('bg-danger')
        }
        else if(Number(resp.stockbalance) == Number(productDetails.stockalertlevel)){
          setStockBalanceBgColour('bg-warning')
        }
        else{
          setStockBalanceBgColour('bg-info')
        }
      }
      setStockLoading(false)
    })
  }

  function getProductDetailsFromId(productid){
    setShowLoading(true)
    getProductForEditDirect(productid).then(resp =>{
      setProductDetails(resp)
      setShowLoading(false)
    })
  }

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  }


  const [productDetails, setProductDetails] = useState({})
  const [selectedProductId, setSelectedProductId] = useState()
  const [productFilteredList, setProductFilteredList] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [ecomEnabled, setEcomEnabled] = useState(false)
  const [stockBalance, setStockBalance] = useState('-')
  const [stockBalanceBgColour, setStockBalanceBgColour] = useState('bg-info')
  const [stockLoading, setStockLoading] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(0)
  const [productSaleList, setProductSaleList] = useState([
    {
      name: "Sales",
      data: [],
    },
  ])

  const [salesEntryList, setSalesEntryList] = useState([])
  const [salesEntry, setSalesEntry] = useState({})
  const [customerDetails, setCustomerDetails] = useState({})
  const [showLoading, setShowLoading] = useState(false)
  const [searchInProgress, setSearchInProgress] = useState(false)
  const [storeDetails, setStoreDetails] = useState({})
  const [selectedItem, setSelectedItem] = useState()
  const [selectedCustId, setSelectedCustId] = useState()
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [customerFilteredList, setCustomerFilteredList] = useState([])
  const [customerSalesSummary, setCustomerSalesSummary] = useState({})

  const { settings , productList } = useSelector(state => ({
    productList: state.Products.products,
    settings: state.Products.settings,
  }))

  useEffect(() => {
    if(settings && settings.length > 0){
      const ecomEnabled = settings.filter(each => each.settingid == 'ECOMMERCE_FLAG')
      if(ecomEnabled && ecomEnabled.length > 0){
        const ecomEnabledValue = ecomEnabled[0].settingvalue
        if(ecomEnabledValue == 'Yes'){
          setEcomEnabled(true)
        }
      }
    }
  }, [settings]);

  useEffect(() => {
    setProductFilteredList(productList)
    scrollToBottom()
    //console.log('productList:'+JSON.stringify(productList))
  }, [productList])


  async function getCustomerSummary(searchCriteria){
    setShowLoading(true)
    getCustomerSalesSummary(searchCriteria).then(result => {
      setCustomerSalesSummary(result)
      setShowLoading(false)
    })
  }

  async function getCustmerSalesList(searchCritiria){
    setSearchInProgress(true)
    getSalesEntryList(searchCritiria).then(result => {
      setSalesEntryList(result)
      setSearchInProgress(false)
    })
  }

  function close(){
    history.push('/view-products')
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  function toLowerCase(str){
    if(str){
      return str.toLowerCase()
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Products" breadcrumbItem="Product Details"/>
          <Card>
            <CardBody className="no-x-padding">
              <Row className="">
                <Col lg="4">
                  <Row>
                    <Col className="text-center fw-medium font-size-15">
                      Products
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3 ms-2 pt-2">
                    <Select
                      onChange={(e) => {
                        setSelectedProduct(e)
                        if(e?.productid){
                          setSelectedProductId(e.productid)
                          getAllDetails(e.productid)
                          const fileredList = productList.filter(each => each.productid == e.productid)
                          setProductFilteredList(fileredList)
                        }
                        else{
                          setProductFilteredList(productList)
                        }
                      }}
                      isClearable
                      value={selectedProduct}
                      getOptionLabel={option=>option.productcode + ' - ' +option.productname}
                      getOptionValue={option=>option.productid}
                      options={productFilteredList}
                      classNamePrefix="select2-selection"
                      isLoading={false}
                      id="productid"
                    />
                  </div>

                  <SimpleBar style={{ maxHeight: "850px" , paddingBottom:"30px"}} autoHide={false}>
                  {productFilteredList.map((entry, i) => (
                    <React.Fragment key={"outer"+i}>
                      {selectedProductId == entry.productid ? <div ref={messagesEndRef} key={"sel-"+i} />: null}
                      <div className={selectedProductId == entry.productid ? "border-bottom pointer-cursor-with-hover px-2 bg-light-blue" : "border-bottom pointer-cursor-with-hover px-2 "} key={i} onClick={()=>{
                        //getSalesEntryDetails(entry)
                        setSelectedProductId(entry.productid)
                        getAllDetails(entry.productid)
                      }}>
                        <CardBody className="no-gutters">
                          <div className="d-flex align-items-center">
                            <div className="pe-1 border-end">
                              <i className="bx bx-cube text-primary h1"></i>
                            </div>

                            <div className="ps-2">
                              {entry.productcode && <p className="text-muted mb-1">{entry.productcode}</p>}
                              <h5>{entry.productname ? entry.productname : "-"}</h5>
                              {entry.productcategory && <p className="text-muted mb-0"> <i className="bx bx-purchase-tag-alt"/> {entry.productcategory} {entry.productsubcategory ? ' / ' + entry.productsubcategory : '' }</p>}
                            </div>
                          </div>
                        </CardBody>
                      </div>
                    </React.Fragment>
                  ))}
                  </SimpleBar>
                </Col>
                <Col lg="8">
                {showLoading ? 
                <div className=" text-center mt-5">
                  <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                </div>
                : 
                <div className="bg-offwhite p-1">
                  <Row className="mt-2">
                    <Col className="text-end">
                      <Button className="btn btn-sm ms-1 me-1" onClick={() => {
                          history.push("/edit-product/"+productDetails.productid)
                        }}
                        >
                        <i className="mdi mdi-pencil me-2"></i>Edit
                      </Button>

                      <Button className="btn btn-sm ms-1 me-1" onClick={() => {
                          close()
                        }}
                        >
                        <i className="fas fa-window-close"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xl="8">
                      <Card className="bg-extra-light-orange bg-soft">
                        <CardBody>
                          <Media>
                            <div className="avatar-md me-4">
                              <span className="avatar-title rounded-circle bg-dark bg-soft text-danger font-size-20">
                                {productDetails.productname ? productDetails.productname.charAt(0).toUpperCase() : ''}
                              </span>
                            </div>
                            <Media className="overflow-hidden" body>
                              <h5 className="text-truncate font-size-15">
                                {productDetails.productname}
                              </h5>
                              <p className="text-muted mb-2">{productDetails.productcode}</p>
                              <p className="text-muted mb-2">{productDetails.productcategory} {productDetails.productsubcategory ? ' / ' + productDetails.productsubcategory : '' }</p>

                              {productDetails.productimages && productDetails.productimages.length > 0 &&
                              <div className="avatar-group">
                                {productDetails.productimages.map((imagename, idx) => 
                                  <div
                                    className="avatar-group-item"
                                    key={idx + "-file"}
                                  >
                                    <Link
                                      to="#"
                                      className="team-member d-inline-block"
                                      id="member1"
                                      onClick={(e) => {
                                        setSelectedFiles(productDetails.productimages)
                                        setphotoIndex(idx)
                                        setisGallery(true)
                                      }}
                                    >
                                      <img
                                        src={imagename}
                                        className="rounded-circle avatar-xs"
                                        alt=""
                                      />
                                    </Link>
                                  </div>
                                )}
                              </div>
                              }

                            </Media>
                          </Media>
                        </CardBody>
                        <div className="ps-4 py-2 border-top">
                          <ul className="list-inline mb-0">
                            <li className="align-items-center d-flex list-inline-item me-3">
                              <Badge className={"ms-0 bg-warning font-size-15 px-2 py-1 me-3"}>
                                {productDetails.producttype}
                              </Badge>
                              Product Active
                              {productDetails.productactive ? 
                              <i className="bx bx-check-circle ms-2 text-success font-size-24 me-3" />  : 
                              <i className="bx bx bx-x-circle ms-2 text-danger font-size-24 me-3" /> }
                              {ecomEnabled && 
                              <>
                              Web Enabled
                              {productDetails.productwebactive ? 
                              <i className="bx bx-check-circle ms-2 text-success font-size-24 me-3" />  : 
                              <i className="bx bx bx-x-circle ms-2 text-danger font-size-24 me-3" /> }
                              </>
                              }
                            </li>
                          </ul>
                        </div>
                      </Card>
                    </Col>
                    <Col xl="4">
                      <Card className={stockBalanceBgColour + " bg-soft"}>
                        <div>
                          <Row>
                            <Col xs="7">
                              <div className="p-3">
                                <h5 className="">Stock Balance</h5>
                                {stockLoading ? 
                                <Spinner style={{ width: '1.7rem', height: '1.7rem' }} className="mt-0 ms-2" color="primary" /> 
                                :
                                <h4 className="mt-2 ps-2 text-primary">{stockBalance}</h4>
                                }
                              </div>
                            </Col>
                            <Col xs="5" className="align-self-center">
                              <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-success">
                                  <i className="bx bx-archive-in font-size-24"></i>
                                </span>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <div className="ps-4 py-2 border-top">
                              <ul className="list-inline mb-0">
                                <li className="align-items-center d-flex list-inline-item me-3">
                                  Track Stock
                                  {productDetails.trackinventory ? 
                                  <i className="bx bx-check-circle ms-2 text-success font-size-24 me-2" />  : 
                                  <i className="bx bx bx-x-circle ms-2 text-danger font-size-24 me-2" /> }
                                  
                                  {productDetails.trackinventory && 
                                  <>
                                  Stock Alert  
                                  <Badge className={"ms-2 bg-warning text-right font-size-16 px-2 py-1"}>
                                    {productDetails.stockalertlevel}
                                  </Badge>
                                  </>
                                  }
                                  
                                </li>
                              </ul>
                            </div>
                          </Row>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col  className="align-self-center">
                      <div className="text-center mt-0 mt-lg-0">
                        <Row>
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                Base Price
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.baseprice).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                MRP
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.mrp).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                Retail Price
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.retailprice).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                Wholesale Price
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.wholesaleprice).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          {ecomEnabled &&
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                Online Price
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.onlineprice).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          }
                          {ecomEnabled &&
                          <Col className="mt-1">
                            <div className="bg-light-orange py-2">
                              <p className="text-muted text-truncate mb-2">
                                Online High. Price
                              </p>
                              <h5 className="mb-0"><i className="bx bx-rupee "></i>{Number(productDetails.onlinehighlightedprice).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                            </div>
                          </Col>
                          }
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <ProductSaleGraph series={productSaleList} />
                  </Row>
                  <Row className="m-0 mt-0">
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-3">Product Details</CardTitle>

                        <div className="table-responsive">
                          <Table className="table ">
                            <tbody>
                              <tr>
                                <td style={{ width: "30%" }}>HSN</td>
                                <td>{productDetails.producthsn}</td>
                              </tr>
                              <tr>
                                <td>Tax</td>
                                <td>{productDetails.producttaxgroup} %</td>
                              </tr>
                              <tr>
                                <td>Base Unit</td>
                                <td>{productDetails.productunit}</td>
                              </tr>
                              <tr>
                                <td>Multi-Unit</td>
                                <td>{productDetails.multiunit ? 'Yes' : 'No'}
                                {(productDetails.multiunitconversions || []).map((formRow, key) => (
                                  <Badge className={"ms-2 px-2 py-1 bg-info font-size-13"} key={key}>
                                    {formRow.conversionunitname}
                                  </Badge>
                                ))}
                                </td>
                              </tr>
                              <tr>
                                <td>Brand</td>
                                <td>{productDetails.productbrand}</td>
                              </tr>
                              <tr>
                                <td>Supplier</td>
                                <td>{productDetails.productsupplier}</td>
                              </tr>
                              <tr>
                                <td>Manufacturer</td>
                                <td>{productDetails.productmanufacturer}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Row>
                </div>
                }
                </Col>
              </Row>
              
            </CardBody>

          </Card>
        </Container>
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={selectedFiles[photoIndex]}
          nextSrc={selectedFiles[(photoIndex + 1) % selectedFiles.length]}
          prevSrc={selectedFiles[(photoIndex + selectedFiles.length - 1) % selectedFiles.length]}
          enableZoom={true}
          onCloseRequest={() => {
            setisGallery(false)
          }}
          onMovePrevRequest={() => {
            setphotoIndex((photoIndex + selectedFiles.length - 1) % selectedFiles.length)
          }}
          onMoveNextRequest={() => {
            setphotoIndex((photoIndex + 1) % selectedFiles.length)
          }}
          imageCaption={selectedFiles[photoIndex]}
        />
      ) : null}
    </React.Fragment>
  )
}

export default ProductListWithDetails
